<template>
    <div>
        <div class="banner">
            <img src="../../assets/images/bg.jpg" />
        </div>
        <div class="main">
            <div class="com-page-title">
                <div class="inner">我的订单</div>
            </div>
            <div class="com-card">
                <div class="com-card-title">历史订单</div>
                <div class="com-card-content">
                    <van-list
                            v-model:loading="loading"
                            :finished="finished"
                            @load="grtOrderList"
                    >
                        <ul class="com-list-cell">
                            <li v-for="order in orderList" :key="order.id" @click="nextStep(order)">
                                <div class="title">
                                    <span>{{order.goodsName}}</span>
                                </div>
                                <div class="category c2">
                                    <span>{{$dateFormat(order.addTime,'yyyy-MM-dd HH:mm:ss')}}</span>
                                </div>
                            </li>
                        </ul>
                        <p class="wu" v-if="showOrder">暂无订单</p>
                    </van-list>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "orderIndex",
        data() {
            return {
                loading: false,
                finished: false,
                orderList: [],
                page: 1,
                limit: 10,
                showOrder:false
            }
        },
        methods: {
            grtOrderList() {
                this.$orderApi.getOrderOkOrders({
                // this.$orderApi.getOrderList({
                    page: this.page,
                    limit: this.limit
                }).then(res => {
                    if (res.success) {
                        this.loading = false
                        const data = res.data
                        if (data.list.length < this.limit) {
                            this.finished = true
                        }
                        this.page ++
                        this.orderList = this.orderList.concat(data.list)
                        if(this.orderList.length == 0){
                            this.showOrder = true
                        }
                    } else {
                        this.$toast(res.errMessage)
                    }
                })
            },
            nextStep(order) {
                this.$router.push({
                    path: '/order/detail',
                    query: {orderId: order.id,orderName: order.goodsName}
                })
            }
        }
    }
</script>

<style scoped>
    .banner {
        height: 300px;
    }

    .banner img {
        width: 100%;
        height: 100%;
    }

    .wu {
        margin: 20px 0;
    }

    .wu {
        text-align: center;
        font-size: 14px;
        color: #B27532;
    }
</style>